module.exports = {
  message: {
    service_desc: 'Используйте утилиту для обмена COS между различными форматами токенов, включая <strong>MainNet Native COS, ERC-20 и BEP-20.</strong>',
    choose_token_type: 'Направление обмена токеном',
    fee_tips: '',
    token_type_erc20_to_bep2: 'ERC-20 => BEP2',
    token_type_erc20_to_native: 'ERC-20 => MainNet Native COS',
    token_type_bep2_to_erc20: 'BEP2 => ERC-20',
    token_type_bep2_to_native: 'BEP2 => MainNet Native COS',
    token_type_native_to_erc20: 'MainNet Native COS => ERC-20',
    token_type_native_to_bep2: 'MainNet Native COS => BEP2',
    token_type_bep20_to_native: 'BEP-20 => MainNet Native COS',
    token_type_native_to_bep20: 'MainNet Native COS => BEP-20',
    enter_address: 'Токен swap целевой учетной записи / адрес',
    enter_exchange_memo: 'Memo (адрес получателя является обменом. Пожалуйста, укажите Memo, чтобы правильно получить COS)',
    create_account_tips: 'У вас нет аккаунта? Создайте!',
    next_btn: 'Следующий шаг',
    start_over_btn: 'Перезапустить',
    ready_to_swap: 'ГОТОВ Swap',
    transfer_prefix: 'Перевести ваш {token}в',
    address: 'АККАУНТ / АДРЕС',
    memo: 'MEMO',
    auto_swap_desc: 'Убедитесь, что вы правильно ввели УЧЕТНУЮ ЗАПИСЬ / АДРЕС. Утилита подкачки токенов отправит соответствующее количество токенов COS на указанный кошелек после получения вашего токена. <strong>Процесс может занять около 5-30 минут<strong>.',
    auto_swap_desc_memo: 'Убедитесь, что вы правильно ввели УЧЕТНУЮ ЗАПИСЬ / АДРЕС и МЕМО. Утилита подкачки токенов отправит соответствующее количество токенов COS на указанный кошелек после получения вашего токена. <strong>Процесс может занять около 5-30 минут<strong>.',
    main_net_address: 'Учетная запись основной сети Contentos',
    bep2_address: 'Адрес BEP2',
    erc20_address: 'Адрес ERC-20',
    bep20_address: 'Адрес BEP-20',
    main_net_token: 'COS MainNet',
    bep2_token: 'BEP2 COS',
    erc20_token: 'ERC-20 COS',
    bep20_token: 'BEP-20 COS',
    ok: 'Подтвердить',
    Cancel: 'Отмена',
    tips: 'Примечания',
    enter_address_tips: 'Пожалуйста, заполните правильный адрес',
    enter_exChange_memo_tips: 'Пожалуйста, введите правильное Memo',
    swap_address_invalid: 'Неверный адрес',
    swap_address_not_exit: 'Аккаунт не существует',
    swap_type_invalid: 'Неверное направление swap токеном',
    swap_system_error: 'Пожалуйста, повторите попытку позже',
    swap_unknown_error: 'Произошла неизвестная ошибка. Пожалуйста, повторите попытку позже.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    paste_warning: 'При вставке адреса убедитесь, что он совпадает с адресом, который вы скопировали.',
    fee_notice: 'Обратите внимание: за каждый обмен будет взиматься комиссия в размере {fee} COS для покрытия расходов на газ при переводе {token} между аккаунтами. Запросы на обмен сумм менее {fee} COS не будут обработаны.',
    fee_subject_to_change: 'Размер комиссии может быть изменён без предварительного уведомления.',
    view_status: 'Просмотр статуса конвертации',
    prev_step: 'Назад',
    go_back: 'Назад',
    transfer_prefix_before: 'Переведите ваш',
    transfer_prefix_after: 'на',
    copy_memo: 'Копировать MEMO',
    copy_address: 'Копировать адрес',
    copy_success: 'Скопировано',
    memo_warning: 'Внимание: при переводе обязательно укажите правильный MEMO. Система выполнит конвертацию на основе фактически полученной суммы и отправит на указанный вами адрес. Не пропускайте MEMO.',
    col_time: 'Время',
    col_target_format: 'Целевой формат',
    col_target_account: 'Целевой аккаунт',
    col_amount: 'Сумма',
    col_status: 'Статус',
    loading: 'Загрузка\u2026',
    no_data: 'Нет данных',
    next_update_hint: 'Данные обновятся через {time}',
    status_done: 'Завершено',
    status_pending: 'В обработке',
    panel_title_status: 'Статус конвертации',
    panel_title_step1: 'Инструмент конвертации токенов',
    panel_title_step2: 'Готово к конвертации токенов',
    panel_subtitle_status: 'Выберите формат исходного токена для просмотра истории конвертаций',
    source_network: 'Формат исходного токена',
    conversion_record: 'История конвертаций',
    new_label: 'Новое'
  }
}
